import createAttachmentFiles from '../../utils/createAttachmentFiles';
import { getItem } from '../../utils/getItem';
import { AttachmentDetails } from 'owa-addins-core';
import { getUserMailboxInfo } from 'owa-client-ids';
import { ComposeTarget, lazyReplyToMessage } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export function displayReplyForm(
    referenceItemId: string,
    isReplyAll: boolean,
    htmlBody: string,
    attachments: AttachmentDetails[]
) {
    if (isFeatureEnabled('rp-popouts')) {
        const item = getItem(referenceItemId);
        const conversationId = item ? item.ConversationId.Id : null;
        const attachmentFiles = createAttachmentFiles(attachments);
        lazyReplyToMessage.importAndExecute({
            referenceItemId: { Id: referenceItemId, mailboxInfo: getUserMailboxInfo() },
            isReplyAll: isReplyAll,
            useFullCompose: true,
            actionSource: 'AddIns',
            instrumentationContexts: [],
            conversationId: conversationId,
            body: htmlBody,
            fullComposeTarget: ComposeTarget.Popout,
            attachmentFiles: attachmentFiles,
        });
    }
}
